import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import { Alert, Card, CardContent } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { PaymentItemsTable } from '@src/components/Admin/PaymentItemsTable';
import { GENERATE_PAYROLL, PENDING_PAYMENTS } from '@src/graphql/queries/payroll';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useClients } from '@src/hooks/useClients';
import { getPayrollNavLinks } from '@src/utilities/topNavHelper';
import { Messages, TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
export const PendingPayments = () => {
    const clientId = useClientIdParam() || 0;
    const { t } = useLocale();
    const [messages, setMessages] = useState([]);
    const { find } = useClients({ id: clientId });
    const client = find(clientId);
    const isParent = !!client?.isParent;
    const { data, loading, error } = useQuery(PENDING_PAYMENTS, {
        variables: {
            spec: {
                clientId,
            },
        },
    });
    const [generatePayrollMutation] = useMutation(GENERATE_PAYROLL, {
        refetchQueries: [{ query: PENDING_PAYMENTS, variables: { spec: { clientId } } }],
    });
    const handleGeneratePayroll = async () => {
        const response = await generatePayrollMutation({
            variables: {
                clientId,
            },
        });
        setMessages(response.data?.generatePayroll?.messages);
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Payments'), navLinks: getPayrollNavLinks(t, clientId || 0, 'pending'), actions: _jsx(TrackableButton, { btnType: 'mui', enText: 'Generate Payroll', tag: 'header', variant: 'contained', className: 'button button--primary margin--bottom_16', onClick: () => handleGeneratePayroll(), children: t('Generate Payroll') }) }), _jsx("div", { children: _jsx(Card, { children: _jsxs(CardContent, { children: [error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: error.message })), _jsx(Messages, { messages: messages, className: 'mb-3' }), _jsx(PaymentItemsTable, { loading: loading, isParent: isParent, showCreated: true, fallbackCurrency: client?.clientConfig?.currency, rows: data?.pendingPayments || [] })] }) }) })] }));
};
